exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".root---3XJjz{display:flex;flex-grow:1}.root---3XJjz:not(:last-child){border-bottom:1px solid #000}.name---3kFuT{width:100%;height:100%;display:flex;justify-content:center;align-items:center;border-right:1px solid #000;background-color:#f89f7a;word-wrap:normal;text-align:center}.name---3kFuT select{width:90%}", ""]);

// Exports
exports.locals = {
	"root": "root---3XJjz",
	"name": "name---3kFuT"
};